<template>
<div class="chapter">
<div class="inner_page">
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_"> </p>
<h1 class="block_1" id="toc_id_2">Dedication</h1>
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_2">To Barbara, my steadfast companion, whose unwavering support and belief in me have been the cornerstone of my journey. Your encouragement has propelled me forward, even in the face of uncertainty. To my dear friend Leandro, whose insightful feedback and spirited debates enriched the pages of this book. And to my parents, who nurtured my curiosity and instilled in me a love for learning. Your guidance and love have shaped me into the person I am today, contributing to my summation of experiences and defining my being.</p>
<p class="block_4" id="calibre_pb_1"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// index_split_001.vue?560845cc